export enum UsageStatistics {
  Projects = 'Project',
  Applied = 'ProjectApplied',
  Granted = 'PaymentGranted',
  Paid = 'PaymentOutgoing',
  Profiles = 'Profile::Profile',
  Messages = 'Message',
  Assets = 'Asset',
  Attachments = 'Attachment',
  AssetsSize = 'AssetSize',
  AttachmentsSize = 'AttachmentSize',
  Tickets = 'Tickets',
  Sms = 'Sms',
  UserMitId = 'UserMitId',
  ProfileMitId = 'ProfileMitId',
  Signatures = 'Signatures',
  AITokens = 'AITokens',
  AIOCR = 'AIOCR'
}

export interface Usage {
  total: number;
  data: number[];
}
